import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import useAlertStore from '@/stores/alertStore';

const ALLOWED_LINK_PROTOCOLS = ['http:', 'https:', 'mailto:'];

const isSafeLinkUrl = (url: string): boolean => {
  try {
    return ALLOWED_LINK_PROTOCOLS.includes(new URL(url, window.location.origin).protocol);
  } catch {
    return false;
  }
};

const AlertComponent = () => {
  const { message, severity, visible, autoHideDuration, hideAlert, linkUrl, position } = useAlertStore();

  const showViewButton = Boolean(linkUrl && isSafeLinkUrl(linkUrl));

  const handleViewClick = () => {
    if (linkUrl && isSafeLinkUrl(linkUrl)) {
      window.open(linkUrl, '_blank', 'noopener,noreferrer');
    }
    hideAlert();
  };

  return (
    <Snackbar
      open={visible}
      autoHideDuration={autoHideDuration}
      onClose={(_event, reason) => {
        // Persistent alerts (no auto-hide, e.g. campaign toasts) must stay until
        // the user explicitly dismisses them — ignore click-away for those.
        if (autoHideDuration === null && reason === 'clickaway') return;
        hideAlert();
      }}
      anchorOrigin={position}
    >
      <Alert
        severity={severity}
        onClose={hideAlert}
        variant="filled"
        action={
          showViewButton ? (
            <Button color="inherit" size="small" onClick={handleViewClick}>
              View
            </Button>
          ) : undefined
        }
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default AlertComponent;
